<div class="gallery-upload-zone">

  <!-- Upload Zone -->
  <div class="gallery-upload-zone__dropzone"
       (click)="onUploadClick()"
       [class.gallery-upload-zone__dropzone--uploading]="isUploadingGallery">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4V16M12 4L8 8M12 4L16 8M4 17V19C4 19.5304 4.21071 20.0391 4.58579 20.4142C4.96086 20.7893 5.46957 21 6 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V17" stroke="#606060" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span class="gallery-upload-zone__upload-text">
      {{ isUploadingGallery ? (uploadingText | translate) : (uploadText | translate) }}
    </span>
    @if (uploadFormats) {
      <span class="gallery-upload-zone__upload-formats">
        {{ uploadFormats | translate }}
      </span>
    }
  </div>

  <input
    #fileInput
    type="file"
    [attr.multiple]="multiple ? '' : null"
    [accept]="accept"
    style="display: none;"
    (change)="onFilesSelected($event)">

  <!-- Uploaded Files List -->
  @if (galleryFiles.length > 0) {
    <div class="gallery-upload-zone__list">
      @for (file of galleryFiles; track $index; let i = $index) {
        @if (file.hasError) {
          <!-- Error row -->
          <div class="gallery-upload-zone__file-row gallery-upload-zone__file-row--error">
            <div class="gallery-upload-zone__file-preview-content">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="9" stroke="#96080B" stroke-width="1.5"/>
                <path d="M10 6V10" stroke="#96080B" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="10" cy="13" r="0.5" fill="#96080B"/>
              </svg>
              <div class="gallery-upload-zone__file-info">
                <span
                  class="gallery-upload-zone__file-name"
                  [customTooltip]="file.fileName"
                  [tooltipDisabled]="file.fileName.length <= 80">
                  {{ file.fileName | truncateFilename }}
                </span>
                <span class="gallery-upload-zone__error-message">{{ file.errorMessage }}</span>
              </div>
            </div>
            <button type="button"
                    class="gallery-upload-zone__action-btn gallery-upload-zone__action-btn--delete"
                    (click)="removeFile(i)">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                <path d="M0.667969 3.33203H12.668" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.3372 3.33203V12.6654C11.3372 13.332 10.6706 13.9987 10.0039 13.9987H3.33724C2.67057 13.9987 2.00391 13.332 2.00391 12.6654V3.33203" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.00391 3.33268V1.99935C4.00391 1.33268 4.67057 0.666016 5.33724 0.666016H8.00391C8.67057 0.666016 9.33724 1.33268 9.33724 1.99935V3.33268" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.33203 6.66602V10.666" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8.00391 6.66602V10.666" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
        } @else {
          <!-- Normal row -->
          <div class="gallery-upload-zone__file-row">
            <div class="gallery-upload-zone__file-preview-content">
              <svg class="gallery-upload-zone__file-icon" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.75 6.08333C0.75 4.21667 0.75 3.28333 1.11333 2.57C1.43291 1.94282 1.94282 1.43291 2.57 1.11333C3.28333 0.75 4.21667 0.75 6.08333 0.75H10.4167C12.2833 0.75 13.2167 0.75 13.93 1.11333C14.5572 1.43291 15.0671 1.94282 15.3867 2.57C15.75 3.28333 15.75 4.21667 15.75 6.08333V10.4167C15.75 12.2833 15.75 13.2167 15.3867 13.93C15.0671 14.5572 14.5572 15.0671 13.93 15.3867C13.2167 15.75 12.2833 15.75 10.4167 15.75H6.08333C4.21667 15.75 3.28333 15.75 2.57 15.3867C1.94282 15.0671 1.43291 14.5572 1.11333 13.93C0.75 13.2167 0.75 12.2833 0.75 10.4167V6.08333Z" stroke="#96080B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <g transform="translate(3, 2.5)">
                  <path d="M12.7725 4.075C7.26417 3.31833 2.51417 7.40833 2.83333 12.8333M0.75 2.41667C0.75 2.85869 0.925595 3.28262 1.23816 3.59518C1.55072 3.90774 1.97464 4.08333 2.41667 4.08333C2.85869 4.08333 3.28262 3.90774 3.59518 3.59518C3.90774 3.28262 4.08333 2.85869 4.08333 2.41667C4.08333 1.97464 3.90774 1.55072 3.59518 1.23816C3.28262 0.925595 2.85869 0.75 2.41667 0.75C1.97464 0.75 1.55072 0.925595 1.23816 1.23816C0.925595 1.55072 0.75 1.97464 0.75 2.41667Z" stroke="#96080B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <g transform="translate(0, 8)">
                  <path d="M0.75 0.804733C3.06667 0.4839 5.14583 1.60307 6.27 3.38807" stroke="#96080B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
              </svg>
              <div class="gallery-upload-zone__file-info">
                <span
                  class="gallery-upload-zone__file-name"
                  [customTooltip]="file.fileName"
                  [tooltipDisabled]="file.fileName.length <= 80">
                  {{ file.fileName | truncateFilename }}
                </span>
                @if (file.fileSize) {
                  <span class="gallery-upload-zone__file-size">{{ file.fileSize }}</span>
                }
              </div>
            </div>
            <div class="gallery-upload-zone__file-actions">
              @if (file.fileUrl) {
                <button type="button"
                        class="gallery-upload-zone__action-btn gallery-upload-zone__action-btn--preview"
                        (click)="previewFile(i)">
                  {{ 'settings.project_details_form.preview_button' | translate }}
                </button>
              }
              <button type="button"
                      class="gallery-upload-zone__action-btn gallery-upload-zone__action-btn--delete"
                      (click)="removeFile(i)">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                  <path d="M0.667969 3.33203H12.668" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11.3372 3.33203V12.6654C11.3372 13.332 10.6706 13.9987 10.0039 13.9987H3.33724C2.67057 13.9987 2.00391 13.332 2.00391 12.6654V3.33203" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.00391 3.33268V1.99935C4.00391 1.33268 4.67057 0.666016 5.33724 0.666016H8.00391C8.67057 0.666016 9.33724 1.33268 9.33724 1.99935V3.33268" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.33203 6.66602V10.666" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8.00391 6.66602V10.666" stroke="#96080B" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        }
      }
    </div>
  }

</div>
